<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="球杆解绑"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <!-- 独立的背景图区域 -->
      <div class="bg-card">
        <img src="@/assets/img/h5/unbind.png" alt="背景图" class="bg-img" />
      </div>

      <!-- 新增：解绑主要提示文字 -->
      <div class="main-tip">仅支持会员退货解绑</div>

      <!-- 独立的文本框区域（放在背景图下方） -->
      <div class="form-card">
        <!-- 球杆编码输入框 -->
        <van-field
            v-model="number"
            name="number"
            label="球杆编码"
            placeholder="请输入球杆编码"
            class="form-input number-input"
            required
            @blur="trimNumber"
        />
        <!-- 解绑原因 textarea 文本框 -->
        <van-field
            v-model="opinion"
            required
            name="opinion"
            label="解绑原因"
            type="textarea"
            placeholder="请输入解绑原因"
            class="form-input reason-input"
            rows="3"
            @blur="trimOpinion"
        />
      </div>

      <!-- 解绑按钮（在文本框下方） -->
      <van-button class="search-btn" block @click="getProgress">解绑</van-button>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {unbindByNumber, updatePasswordToVerify} from "@/api/sales";
import {Dialog, Toast} from "vant";

export default {
  data() {
    return {
      number: '', // 球杆编码
      opinion: '', // 解绑原因
    }
  },
  methods: {
    // 顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },

    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
        // PC端弹窗适配
        style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
      });
    },
    // 球杆编码去空格
    trimNumber() {
      this.number = this.number.trim();
    },
    // 解绑原因去空格
    trimOpinion() {
      this.opinion = this.opinion.trim();
    },
    // 球杆解绑（解绑原因非空校验）
    getProgress() {
      this.trimNumber(); // 球杆编码去空格
      this.trimOpinion(); // 解绑原因去空格

      // 1. 校验球杆编码
      if (!this.number) {
        Toast('请输入球杆编码');
        return;
      }
      // 2. 校验解绑原因
      if (!this.opinion) {
        Toast('请输入解绑原因');
        return;
      }

      // 确认弹窗（PC端适配）
      Dialog.confirm({
        title: '确认解绑',
        message: '是否确认解绑该球杆？解绑后将解除该球杆编码的绑定关系，请谨慎操作！',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        style: { width: '90%', maxWidth: '600px', fontSize: '20px' }
      }).then(() => {
        this.doUnbind();
      }).catch(() => {
      });
    },
    // 解绑核心逻辑（传递解绑原因参数）
    async doUnbind() {
      // 构造接口参数：包含球杆编码和解绑原因
      const params = {
        keyWord: this.number,
        opinion: this.opinion
      };
      try {
        const res = await unbindByNumber(params);
        if (res.code === 200) {
          this.showDialogMsg(res.returnMsg || '球杆解绑成功！');
          // 解绑成功后清空所有输入
          this.number = '';
          this.opinion = '';
        } else {
          this.showDialogMsg(res.returnMsg || '球杆解绑失败，请稍后重试');
        }
      } catch (err) {
        this.showDialogMsg('网络异常，解绑失败，请稍后重试');
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 继承公共样式的黑金主题色变量
$black: #000000;
$gold: #D4AF37;
$dark-gold: #B8860B;

::v-deep .van-field{
  margin-bottom: 0 !important;
}
// 导航栏样式
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
  // PC端导航栏箭头适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
  // PC端返回文字适配
  @media (min-width: 768px) {
    font-size: 30px !important;
  }
}
.top-bar {
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  // PC端导航栏整体适配
  @media (min-width: 768px) {
    height: 70px !important;
    ::v-deep .van-nav-bar__title {
      font-size: 30px !important;
      line-height: 70px !important;
    }
  }
}

// 整体容器（核心：PC端50%宽度居中）
.h5-container {
  @media (min-width: 768px) {
    width: 50%;
    margin: 0 auto;
    min-height: 110vh;
    box-sizing: border-box;
    background-color: #1a1a1a;
  }
}
.container-item {
  padding: 0 16px;
  margin-bottom: 60px;
  // PC端容器适配
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 42px;
  }
}

// 独立背景图区域
.bg-card {
  margin: 16px 0;
  border-radius: 12px;
  overflow: hidden; // 防止图片超出圆角
  border: 2px solid $dark-gold;
  box-sizing: border-box;
  // PC端背景图容器适配
  @media (min-width: 768px) {
    height: 400px;
    border-radius: 12px;
    margin: 20px auto;
    border-width: 2px; // 加粗边框
  }
}
.bg-img {
  width: 100%;
  height: auto; // 自适应高度，保持图片比例
  display: block; // 去掉图片默认间隙
  // PC端背景图适配
  @media (min-width: 768px) {
    min-height: 400px; // 限制最大高度，保证比例
    object-fit: cover; // 保持图片比例
  }
}

// 新增：主要提示文字样式
.main-tip {
  text-align: center;
  color: $dark-gold;
  font-size: 15px;
  font-weight: bold;
  margin: 0 0 12px;
  line-height: 1.4;
  // PC端提示文字适配
  @media (min-width: 768px) {
    font-size: 20px;
    margin: 0 0 20px;
    font-weight: 600;
  }
}

// 独立文本框区域
.form-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  // PC端表单容器适配
  @media (min-width: 768px) {
    padding: 25px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }
}
.form-input {
  border-radius: 10px;
  border-bottom: none;
  background: #f8f8f8;
  // PC端输入框基础适配
  @media (min-width: 768px) {
    --van-field-font-size: 18px;
    height: 50px;
    min-height: 50px;
    line-height: 50px;
    padding: 0 15px;
    border-radius: 12px;
  }
}
.number-input {
  margin-bottom: 15px; // 编码和原因输入框之间的间距
  // PC端编码输入框适配
  @media (min-width: 768px) {
    margin-bottom: 20px;
    ::v-deep .van-field__label {
      width: 80px;
      font-size: 18px;
      line-height: 50px;
    }
    ::v-deep .van-field__control {
      font-size: 18px;
      height: 50px;
      line-height: 50px;
    }
  }
}
.reason-input {
  background: #f8f8f8;
  // PC端textarea适配
  @media (min-width: 768px) {
    height: auto !important;
    min-height: 120px;
    ::v-deep .van-field__label {
      width: 80px;
      font-size: 18px;
      line-height: 1.5;
      margin-bottom: 5px;
    }
    ::v-deep .van-field__control {
      font-size: 18px;
      min-height: 100px;
      padding: 10px 15px;
      line-height: 1.5;
    }
  }
}

// 解绑按钮样式
.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  color: $black;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  // PC端按钮适配
  @media (min-width: 768px) {
    height: 80px;
    font-size: 36px;
    border-radius: 12px;
    margin: 0 auto 30px;
    width: calc(100% - 40px);
    &:hover {
      background: $dark-gold;
      cursor: pointer;
    }
  }
}

// 弹窗按钮样式适配
::v-deep .van-dialog__confirm {
  color: $dark-gold !important;
  // PC端弹窗按钮适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__cancel {
  // PC端弹窗取消按钮适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 0 30px !important;
  }
}
::v-deep .van-dialog__title {
  // PC端弹窗标题适配
  @media (min-width: 768px) {
    font-size: 24px !important;
    margin-bottom: 15px !important;
  }
}
::v-deep .van-dialog__message {
  // PC端弹窗内容适配
  @media (min-width: 768px) {
    font-size: 20px !important;
    line-height: 1.6 !important;
  }
}

// Toast提示PC端适配
::v-deep .van-toast {
  @media (min-width: 768px) {
    font-size: 20px !important;
    padding: 15px 25px !important;
    border-radius: 10px !important;
  }
}
</style>